export enum CheckBoxStates {
  INDIFERENT = -1,
  UNCHECKED = 0,
  CHECKED = 1
}
